// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"651":"web","884":"admin","933":"auth"}[chunkId] || chunkId) + "." + {"651":"31bec5f2","884":"2fc09ec0","902":"bf389f0e","933":"edcf40e4","960":"b45a4da7"}[chunkId] + ".js";
};